import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaArrowRight,
  FaLinkedinIn,
  FaTwitter,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="ltn-footer">
      {/* Main Footer */}
      <Container>
        <Row className="gy-5">
          {/* Brand */}
          <Col lg={4} md={6}>
            <div className="footer-brand">
              <a href="/" className="footer-logo brand-logo">
                <img src="/images/logo.png" alt="Logo" />
              </a>

              <p className="footer-description">
                A smarter way to work with documents, research, notes, and
                ideas. Bring your information together, connect what matters,
                and turn complex documents into meaningful insights.
              </p>

              {/* Social */}
              <div className="footer-socials">
                <a href="#" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>

                <a href="#" aria-label="Twitter">
                  <FaTwitter />
                </a>

                <a href="#" aria-label="Facebook">
                  <FaFacebookF />
                </a>

                <a href="#" aria-label="Instagram">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={6} sm={6}>
            <div className="footer-column">
              <h5>Quick Links</h5>

              <ul>
                <li>
                  <a href="/">Home</a>
                </li>

                <li>
                  <a href="/features">Features</a>
                </li>

                <li>
                  <a href="/about">About Us</a>
                </li>

                <li>
                  <a href="/enterprise">Enterprise</a>
                </li>

                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Product */}
          <Col lg={3} md={6} sm={6}>
            <div className="footer-column">
              <h5>Product</h5>

              <ul>
                <li>
                  <a href="/features">Connected Workspace</a>
                </li>

                <li>
                  <a href="/features">Document Annotation</a>
                </li>

                <li>
                  <a href="/features">Note Taking</a>
                </li>

                <li>
                  <a href="/features">Research Tools</a>
                </li>

                <li>
                  <a href="/features">Collaboration</a>
                </li>

                <li>
                  <a href="/features">Cross-Device Sync</a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Resources */}
          <Col lg={3} md={6}>
            <div className="footer-column">
              <h5>Resources</h5>

              <ul>
                <li>
                  <a href="/how-it-works">How It Works</a>
                </li>

                <li>
                  <a href="/help">Help Center</a>
                </li>

                <li>
                  <a href="/faq">FAQs</a>
                </li>

                <li>
                  <a href="/privacy">Privacy Policy</a>
                </li>

                <li>
                  <a href="/terms">Terms of Use</a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* CTA */}
        <div className="footer-cta">
          <Row className="align-items-center gy-4">
            <Col md={8}>
              <span className="footer-cta-small">
                READY TO THINK DIFFERENTLY?
              </span>

              <h3>Transform the way you work with documents.</h3>
            </Col>

            <Col md={4} className="text-md-end">
              <a href="/contact" className="footer-cta-btn">
                Get Started
                <FaArrowRight />
              </a>
            </Col>
          </Row>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>© 2026 LiquidTextNotability. All rights reserved.</p>

          <p className="footer-tagline">Read. Connect. Understand.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
